import * as yup from 'yup';

export const commonSpecialHandlingIndMappingValidation: { [x: string]: any; } = {
    specialHandlingCodeList: yup.array().of(yup.string()).required("Missing.").min(1, "Missing."),
    specialHandlingInd: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createSpecialHandlingIndMappingValidation: { [x: string]: any; } = {
    ...commonSpecialHandlingIndMappingValidation,
};

export const createSpecialHandlingIndMappingValidationSchema = yup.object().shape(createSpecialHandlingIndMappingValidation);

